import * as R from 'ramda'
import allRoutes from '@scope/router/index'
import i18n from '@/locales'
import {
  MONITOR_TEMPLATE_VMINSTANCE,
  MONITOR_TEMPLATE_HOST,
  MONITOR_TEMPLATE_VMINSTANCE_CONTAINER,
  MONITOR_TEMPLATE_CONTAINER,
  MONITOR_TEMPLATE_RDS,
  MONITOR_TEMPLATE_REDIS,
  MONITOR_TEMPLATE_BLOCKSTORAGE,
  MONITOR_TEMPLATE_BUCKET,
  MONITOR_TEMPLATE_BAREMETAL,
} from '@Monitor/utils/monitorTemplate'

export const CATEGORY_LABEL_MAP = {
  vminstance_hidden_menus: i18n.t('cloudenv.text_507'),
  vminstance_container_hidden_menus: i18n.t('cloudenv.vminstance_container_hidden_menus'),
  baremetal_hidden_menus: i18n.t('cloudenv.baremetal_hidden_menus'),
  image_hidden_menus: i18n.t('cloudenv.text_564'),
  disk_hidden_menus: i18n.t('cloudenv.disk_hidden_menus'),
  sub_hidden_menus: i18n.t('cloudenv.sub_hidden_menus'),
  vminstance_configured_callback_address: i18n.t('cloudenv.text_508'),
  document_configured_callback_address: i18n.t('system.strategydefinition.document_configured_callback_address'),
  // bill_associate_hidden_columns: i18n.t('bill.bill_associate_hidden_columns'),
  bill_resource_hidden_columns: i18n.t('bill.bill_resource_hidden_columns'),
  bill_detail_hidden_columns: i18n.t('bill.bill_detail_hidden_columns'),
  server_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.server')]),
  disk_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.disk')]),
  snapshot_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.snapshot')]),
  eip_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.eip')]),
  network_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.network')]),
  oss_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.bucket')]),
  rds_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.rds')]),
  redis_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.redis')]),
  slb_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.lb')]),
  mongodb_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.mongodb')]),
  vpc_hidden_columns: i18n.t('system.hiden_resource_columns', [i18n.t('dictionary.vpc')]),
  navbar_hidden_items: i18n.t('system.navbar_hidden_items'),
  dashboard_hidden_actions: i18n.t('system.dashboard_hidden_actions'),
  fee_hidden_items: i18n.t('system.hidden_fee_items'),
  server_duration: i18n.t('system.category.server_duration'),
  [MONITOR_TEMPLATE_VMINSTANCE]: i18n.t('system.strategydefinition.vminstance_monitor_template'),
  [MONITOR_TEMPLATE_HOST]: i18n.t('system.strategydefinition.host_monitor_template'),
  [MONITOR_TEMPLATE_VMINSTANCE_CONTAINER]: i18n.t('system.strategydefinition.vminstance_container_monitor_template'),
  [MONITOR_TEMPLATE_CONTAINER]: i18n.t('system.strategydefinition.container_monitor_template'),
  [MONITOR_TEMPLATE_RDS]: i18n.t('system.strategydefinition.rds_monitor_template'),
  [MONITOR_TEMPLATE_REDIS]: i18n.t('system.strategydefinition.redis_monitor_template'),
  [MONITOR_TEMPLATE_BLOCKSTORAGE]: i18n.t('system.strategydefinition.blockstorage_monitor_template'),
  [MONITOR_TEMPLATE_BUCKET]: i18n.t('system.strategydefinition.bucket_monitor_template'),
  [MONITOR_TEMPLATE_BAREMETAL]: i18n.t('system.strategydefinition.baremetal_monitor_template'),
  // custom_resource_list_display_fields: i18n.t('system.category.custom_resource_list_display_fields'),
}

export const CATEGORY_KEYS = {
  VMINSTANCE_HIDDEN_MENUS: 'vminstance_hidden_menus',
  VMINSTANCE_CONTAINER_HIDDEN_MENUS: 'vminstance_container_hidden_menus',
  BAREMETAL_HIDDEN_MENUS: 'baremetal_hidden_menus',
  VMINSTANCE_CONFIGURED_CALLBACK_ADDRESS: 'vminstance_configured_callback_address',
  DOCUMENT_CONFIGURED_CALLBACK_ADDRESS: 'document_configured_callback_address',
  IMAGE_HIDDEN_MENUS: 'image_hidden_menus',
  DISK_HIDDEN_MENUS: 'disk_hidden_menus',
  SUB_HIDDEN_MENUS: 'sub_hidden_menus',
  // BILL_ASSOCIATE_HIDDEN_COLUMNS: 'bill_associate_hidden_columns',
  BILL_RESOURCE_HIDDEN_COLUMNS: 'bill_resource_hidden_columns',
  BILL_DETAIL_HIDDEN_COLUMNS: 'bill_detail_hidden_columns',
  SERVER_HIDDEN_COLUMNS: 'server_hidden_columns',
  DISK_HIDDEN_COLUMNS: 'disk_hidden_columns',
  SNAPSHOT_HIDDEN_COLUMNS: 'snapshot_hidden_columns',
  EIP_HIDDEN_COLUMNS: 'eip_hidden_columns',
  NETWORK_HIDDEN_COLUMNS: 'network_hidden_columns',
  OSS_HIDDEN_COLUMNS: 'oss_hidden_columns',
  RDS_HIDDEN_COLUMNS: 'rds_hidden_columns',
  REDIS_HIDDEN_COLUMNS: 'redis_hidden_columns',
  SLB_HIDDEN_COLUMNS: 'slb_hidden_columns',
  MONGODB_HIDDEN_COLUMNS: 'mongodb_hidden_columns',
  VPC_HIDDEN_COLUMNS: 'vpc_hidden_columns',
  NAVBAR_HIDDEN_ITEMS: 'navbar_hidden_items',
  DASHBOARD_HIDDEN_ACTIONS: 'dashboard_hidden_actions',
  FEE_HIDDEN_ITEMS: 'fee_hidden_items',
  SERVER_DURATION: 'server_duration',
  VMINSTANCE_MONITOR_TEMPLATE: MONITOR_TEMPLATE_VMINSTANCE,
  HOST_MONITOR_TEMPLATE: MONITOR_TEMPLATE_HOST,
  VMINSTANCE_CONTAINER_MONITOR_TEMPLATE: MONITOR_TEMPLATE_VMINSTANCE_CONTAINER,
  CONTAINER_MONITOR_TEMPLATE: MONITOR_TEMPLATE_CONTAINER,
  RDS_MONITOR_TEMPLATE: MONITOR_TEMPLATE_RDS,
  REDIS_MONITOR_TEMPLATE: MONITOR_TEMPLATE_REDIS,
  BLOCKSTORAGE_MONITOR_TEMPLATE: MONITOR_TEMPLATE_BLOCKSTORAGE,
  BUCKET_MONITOR_TEMPLATE: MONITOR_TEMPLATE_BUCKET,
  BAREMETAL_MONITOR_TEMPLATE: MONITOR_TEMPLATE_BAREMETAL,
  // CUSTOM_RESOURCE_LIST_DISPLAY_FIELDS: 'custom_resource_list_display_fields',
}

// 策略类型按用途分组
export const CATEGORY_GROUPS = [
  { key: 'menus', label: i18n.t('system.strategydefinition.group_menus') },
  { key: 'columns', label: i18n.t('system.strategydefinition.group_columns') },
  { key: 'navigation', label: i18n.t('system.strategydefinition.group_navigation') },
  { key: 'bill', label: i18n.t('system.strategydefinition.group_bill') },
  { key: 'callback', label: i18n.t('system.strategydefinition.group_callback') },
  { key: 'monitor', label: i18n.t('system.strategydefinition.group_monitor') },
  { key: 'other', label: i18n.t('system.strategydefinition.group_other') },
]

export const categories = [
  {
    key: CATEGORY_KEYS.VMINSTANCE_HIDDEN_MENUS,
    group: 'menus',
    label: i18n.t('cloudenv.text_507'),
    action: i18n.t('cloudenv.text_509'),
    component: 'HiddenMenus',
  },
  {
    key: CATEGORY_KEYS.VMINSTANCE_CONTAINER_HIDDEN_MENUS,
    group: 'menus',
    label: i18n.t('cloudenv.vminstance_container_hidden_menus'),
    action: i18n.t('cloudenv.text_509'),
    component: 'HiddenMenus',
  },
  {
    key: CATEGORY_KEYS.BAREMETAL_HIDDEN_MENUS,
    group: 'menus',
    label: i18n.t('cloudenv.baremetal_hidden_menus'),
    action: i18n.t('cloudenv.text_509'),
    component: 'HiddenMenus',
  },
  {
    key: CATEGORY_KEYS.VMINSTANCE_CONFIGURED_CALLBACK_ADDRESS,
    group: 'callback',
    label: i18n.t('cloudenv.text_508'),
    action: i18n.t('cloudenv.text_510'),
    component: 'ConfiguredCallbackAddress',
  },
  {
    key: CATEGORY_KEYS.DOCUMENT_CONFIGURED_CALLBACK_ADDRESS,
    group: 'callback',
    label: i18n.t('system.strategydefinition.config_document'),
    action: i18n.t('system.strategydefinition.document'),
    component: 'ConfiguredCallbackAddress',
  },
  {
    key: CATEGORY_KEYS.IMAGE_HIDDEN_MENUS,
    group: 'menus',
    label: i18n.t('cloudenv.text_564'),
    action: i18n.t('cloudenv.text_509'),
    component: 'HiddenMenus',
  },
  {
    key: CATEGORY_KEYS.DISK_HIDDEN_MENUS,
    group: 'menus',
    label: i18n.t('cloudenv.disk_hidden_menus'),
    action: i18n.t('cloudenv.text_509'),
    component: 'HiddenMenus',
  },
  {
    key: CATEGORY_KEYS.SUB_HIDDEN_MENUS,
    group: 'menus',
    label: i18n.t('cloudenv.sub_hidden_menus'),
    action: i18n.t('cloudenv.text_509'),
    component: 'HiddenMenus',
  },
  // {
  //   key: CATEGORY_KEYS.BILL_ASSOCIATE_HIDDEN_COLUMNS,
  //   label: i18n.t('bill.bill_associate_hidden_columns'),
  //   action: i18n.t('cloudenv.text_509'),
  //   component: 'HiddenMenus',
  // },
  {
    key: CATEGORY_KEYS.BILL_RESOURCE_HIDDEN_COLUMNS,
    group: 'bill',
    label: i18n.t('bill.bill_resource_hidden_columns'),
    action: i18n.t('cloudenv.text_509'),
    component: 'HiddenMenus',
  },
  {
    key: CATEGORY_KEYS.BILL_DETAIL_HIDDEN_COLUMNS,
    group: 'bill',
    label: i18n.t('bill.bill_detail_hidden_columns'),
    action: i18n.t('cloudenv.text_509'),
    component: 'HiddenMenus',
  },
  {
    key: CATEGORY_KEYS.SERVER_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.server_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.DISK_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.disk_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.SNAPSHOT_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.snapshot_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.EIP_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.eip_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.NETWORK_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.network_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.OSS_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.oss_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.RDS_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.rds_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.REDIS_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.redis_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.SLB_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.slb_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.MONGODB_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.mongodb_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.VPC_HIDDEN_COLUMNS,
    group: 'columns',
    label: CATEGORY_LABEL_MAP.vpc_hidden_columns,
    action: i18n.t('system.category.hidden_fields'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.NAVBAR_HIDDEN_ITEMS,
    group: 'navigation',
    label: CATEGORY_LABEL_MAP.navbar_hidden_items,
    action: i18n.t('system.category.hidden_navbar_items'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.DASHBOARD_HIDDEN_ACTIONS,
    group: 'navigation',
    label: CATEGORY_LABEL_MAP.dashboard_hidden_actions,
    action: i18n.t('system.dashboard_hidden_actions'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.FEE_HIDDEN_ITEMS,
    group: 'bill',
    label: CATEGORY_LABEL_MAP.fee_hidden_items,
    action: i18n.t('system.hidden_fee_items'),
    component: 'HiddenFields',
  },
  {
    key: CATEGORY_KEYS.SERVER_DURATION,
    group: 'other',
    label: CATEGORY_LABEL_MAP.server_duration,
    action: i18n.t('system.category.server_duration'),
    component: 'ServerDuration',
  },
  {
    // 监控模板不再单独分配资源，配置后对所有同类资源生效
    key: CATEGORY_KEYS.VMINSTANCE_MONITOR_TEMPLATE,
    group: 'monitor',
    label: CATEGORY_LABEL_MAP[MONITOR_TEMPLATE_VMINSTANCE],
    action: i18n.t('system.strategydefinition.config_monitor_template'),
    component: 'MonitorTemplate',
  },
  {
    // 宿主机监控模板，配置后对所有宿主机生效
    key: CATEGORY_KEYS.HOST_MONITOR_TEMPLATE,
    group: 'monitor',
    label: CATEGORY_LABEL_MAP[MONITOR_TEMPLATE_HOST],
    action: i18n.t('system.strategydefinition.config_monitor_template'),
    component: 'MonitorTemplate',
  },
  {
    // 容器主机监控模板，配置后对所有容器主机生效
    key: CATEGORY_KEYS.VMINSTANCE_CONTAINER_MONITOR_TEMPLATE,
    group: 'monitor',
    label: CATEGORY_LABEL_MAP[MONITOR_TEMPLATE_VMINSTANCE_CONTAINER],
    action: i18n.t('system.strategydefinition.config_monitor_template'),
    component: 'MonitorTemplate',
  },
  {
    // 容器监控模板，配置后对容器主机内的全部容器生效
    key: CATEGORY_KEYS.CONTAINER_MONITOR_TEMPLATE,
    group: 'monitor',
    label: CATEGORY_LABEL_MAP[MONITOR_TEMPLATE_CONTAINER],
    action: i18n.t('system.strategydefinition.config_monitor_template'),
    component: 'MonitorTemplate',
  },
  {
    // RDS 监控模板，配置后对所有 RDS 实例生效
    key: CATEGORY_KEYS.RDS_MONITOR_TEMPLATE,
    group: 'monitor',
    label: CATEGORY_LABEL_MAP[MONITOR_TEMPLATE_RDS],
    action: i18n.t('system.strategydefinition.config_monitor_template'),
    component: 'MonitorTemplate',
  },
  {
    // Redis 监控模板，配置后对所有 Redis 实例生效
    key: CATEGORY_KEYS.REDIS_MONITOR_TEMPLATE,
    group: 'monitor',
    label: CATEGORY_LABEL_MAP[MONITOR_TEMPLATE_REDIS],
    action: i18n.t('system.strategydefinition.config_monitor_template'),
    component: 'MonitorTemplate',
  },
  {
    // 块存储监控模板，配置后对所有块存储生效
    key: CATEGORY_KEYS.BLOCKSTORAGE_MONITOR_TEMPLATE,
    group: 'monitor',
    label: CATEGORY_LABEL_MAP[MONITOR_TEMPLATE_BLOCKSTORAGE],
    action: i18n.t('system.strategydefinition.config_monitor_template'),
    component: 'MonitorTemplate',
  },
  {
    // 存储桶监控模板，配置后对所有存储桶生效
    key: CATEGORY_KEYS.BUCKET_MONITOR_TEMPLATE,
    group: 'monitor',
    label: CATEGORY_LABEL_MAP[MONITOR_TEMPLATE_BUCKET],
    action: i18n.t('system.strategydefinition.config_monitor_template'),
    component: 'MonitorTemplate',
  },
  {
    // 裸金属监控模板，配置后对所有裸金属生效（物理机复用裸金属监控，同时生效）
    key: CATEGORY_KEYS.BAREMETAL_MONITOR_TEMPLATE,
    group: 'monitor',
    label: CATEGORY_LABEL_MAP[MONITOR_TEMPLATE_BAREMETAL],
    action: i18n.t('system.strategydefinition.config_monitor_template'),
    component: 'MonitorTemplate',
  },
]

/**
 * 按用途分组后的策略类型，供下拉分组展示使用
 * @returns {Array<{key: String, label: String, items: Array}>}
 */
export const categoryGroups = CATEGORY_GROUPS
  .map(group => ({
    ...group,
    items: categories.filter(item => item.group === group.key),
  }))
  .filter(group => group.items.length > 0)

const _policies = {
  [CATEGORY_KEYS.VMINSTANCE_HIDDEN_MENUS]: [
    { label: i18n.t('cloudenv.text_104'), value: 'server_create' },
    { label: i18n.t('cloudenv.text_511'), value: 'server_perform_start' },
    { label: i18n.t('cloudenv.text_512'), value: 'server_perform_stop' },
    { label: i18n.t('cloudenv.text_513'), value: 'server_perform_restart' },
    { label: i18n.t('cloudenv.text_514'), value: 'server_perform_reset' },
    { label: i18n.t('cloudenv.text_515'), value: 'server_perform_suspend' },
    { label: i18n.t('cloudenv.text_516'), value: 'server_perform_resume' },
    { label: i18n.t('cloudenv.text_516'), value: 'server_perform_resume' },
    { label: i18n.t('compute.start_rescue'), value: 'server_perform_start_rescue' },
    { label: i18n.t('compute.stop_rescue'), value: 'server_perform_stop_rescue' },
    { label: i18n.t('cloudenv.text_354'), value: 'server_perform_syncstatus' },
    { label: i18n.t('compute.sync_config'), value: 'server_perform_sync_config' },
    { label: i18n.t('compute.vnc_panic_screenshot'), value: 'server_perform_screen_dump' },
    { label: i18n.t('compute.kickstart_complete'), value: 'server_perform_kickstart_complete' },
    { label: i18n.t('cloudenv.text_406'), value: 'server_perform_update' },
    { label: i18n.t('compute.change_boot_index'), value: 'server_perform_set_boot_index' },
    { label: i18n.t('compute.bind_physical_cpu'), value: 'server_cpuset_cores' },
    { label: i18n.t('cloudenv.text_517'), value: 'server_perform_rebuild_root' },
    { label: i18n.t('cloudenv.text_518'), value: 'server_perform_change_config' },
    { label: i18n.t('cloudenv.text_519'), value: 'server_perform_change_owner' },
    { label: i18n.t('compute.text_283'), value: 'server_perform_set_user_metadata' },
    { label: i18n.t('cloudenv.text_520'), value: 'server_perform_create_snapshot' },
    { label: i18n.t('compute.create_disk_backup2'), value: 'server_perform_create_backup' },
    { label: i18n.t('cloudenv.text_521'), value: 'server_perform_create_same_config' },
    { label: i18n.t('compute.set_host_isolated_device'), value: 'server_perform_set_gpu' },
    { label: i18n.t('cloudenv.text_523'), value: 'server_perform_set_disk_speed' },
    { label: i18n.t('cloudenv.text_524'), value: 'server_perform_cancel_expire' },
    { label: i18n.t('cloudenv.text_525'), value: 'server_perform_clone' },
    { label: i18n.t('compute.bastionHost.add_bastion_host'), value: 'server_add_to_bastion' },
    { label: i18n.t('cloudenv.text_526'), value: 'server_perform_add_instancegroup' },
    { label: i18n.t('cloudenv.text_527'), value: 'server_perform_Renew' },
    { label: i18n.t('cloudenv.text_528'), value: 'server_perform_auto_renewal' },
    { label: i18n.t('compute.change_billing_type'), value: 'server_perform_change_billing_type' },
    { label: i18n.t('cloudenv.text_529'), value: 'server_perform_reset_password' },
    { label: i18n.t('cloudenv.text_530'), value: 'server_perform_bind_key' },
    { label: i18n.t('cloudenv.text_531'), value: 'server_perform_unbind_key' },
    { label: i18n.t('cloudenv.text_532'), value: 'server_perform_save_image' },
    { label: i18n.t('cloudenv.text_533'), value: 'server_perform_mount_iso' },
    { label: i18n.t('cloudenv.text_535'), value: 'server_perform_add_secgroup' },
    { label: i18n.t('cloudenv.text_536'), value: 'server_perform_bind_elastic_public_ip' },
    { label: i18n.t('cloudenv.text_537'), value: 'server_perform_unbind_elastic_public_ip' },
    { label: i18n.t('cloudenv.text_538'), value: 'server_perform_public_ip_to_eip' },
    { label: i18n.t('cloudenv.text_539'), value: 'server_perform_set_source_check' },
    { label: i18n.t('cloudenv.text_540'), value: 'server_perform_add_backup' },
    { label: i18n.t('cloudenv.text_541'), value: 'server_perform_delete_backup' },
    { label: i18n.t('cloudenv.text_542'), value: 'server_perform_transfer' },
    { label: i18n.t('compute.server.quick.recovery'), value: 'server_perform_migrate' },
    { label: i18n.t('cloudenv.text_543'), value: 'server_set_delete_protection' },
    { label: i18n.t('cloudenv.text_108'), value: 'server_perform_delete' },
    { label: i18n.t('cloudenv.text_559'), value: 'server_web_console' },
    { label: i18n.t('cloudenv.text_561'), value: 'server_add_network_card' },
    { label: i18n.t('cloudenv.text_546'), value: 'server_edit_bandwidth' },
    { label: i18n.t('compute.vminstance.actions.setup_ssh_authentication'), value: 'server_perform_setup_ssh_proxy' },
    { label: i18n.t('compute.vminstance.actions.detect_ssh_authentication'), value: 'server_perform_detect_ssh_proxy' },
    { label: i18n.t('cloudenv.server_change_ip'), value: 'server_change_ip' },
    { label: i18n.t('compute.change_sub_ip'), value: 'server_change_sub_ip' },
    { label: i18n.t('cloudenv.server_detach_nic'), value: 'server_detach_nic' },
    { label: i18n.t('compute.vminstance.change_disk_storage'), value: 'server_perform_change_disk_storage' },
  ],
  [CATEGORY_KEYS.VMINSTANCE_CONTAINER_HIDDEN_MENUS]: [
    { label: i18n.t('cloudenv.text_104'), value: 'server_create' },
    { label: i18n.t('compute.repo.terminal'), value: 'server_web_console' },
    { label: i18n.t('cloudenv.text_511'), value: 'server_perform_start' },
    { label: i18n.t('cloudenv.text_512'), value: 'server_perform_stop' },
    { label: i18n.t('cloudenv.text_513'), value: 'server_perform_restart' },
    { label: i18n.t('cloudenv.text_514'), value: 'server_perform_reset' },
    { label: i18n.t('cloudenv.text_354'), value: 'server_perform_syncstatus' },
    { label: i18n.t('compute.sync_config'), value: 'server_perform_sync_config' },
    { label: i18n.t('cloudenv.text_521'), value: 'server_perform_create_same_config' },
    { label: i18n.t('cloudenv.text_519'), value: 'server_perform_change_owner' },
    { label: i18n.t('cloudenv.text_524'), value: 'server_perform_cancel_expire' },
    { label: i18n.t('compute.text_283'), value: 'server_perform_set_user_metadata' },
    { label: i18n.t('cloudenv.text_526'), value: 'server_perform_add_instancegroup' },
    { label: i18n.t('cloudenv.text_518'), value: 'server_perform_change_config' },
    { label: i18n.t('compute.set_host_isolated_device'), value: 'server_perform_set_gpu' },
    { label: i18n.t('cloudenv.text_535'), value: 'server_perform_add_secgroup' },
    { label: i18n.t('cloudenv.text_539'), value: 'server_perform_set_source_check' },
    { label: i18n.t('cloudenv.text_536'), value: 'server_perform_bind_elastic_public_ip' },
    { label: i18n.t('cloudenv.text_537'), value: 'server_perform_unbind_elastic_public_ip' },
    { label: i18n.t('cloudenv.text_543'), value: 'server_set_delete_protection' },
    { label: i18n.t('cloudenv.text_108'), value: 'server_perform_delete' },
  ],
  [CATEGORY_KEYS.BAREMETAL_HIDDEN_MENUS]: [
    { label: i18n.t('cloudenv.text_104'), value: 'server_create' },
    { label: i18n.t('cloudenv.text_559'), value: 'server_web_console' },
    { label: i18n.t('cloudenv.text_511'), value: 'server_perform_start' },
    { label: i18n.t('cloudenv.text_512'), value: 'server_perform_stop' },
    { label: i18n.t('cloudenv.text_513'), value: 'server_perform_restart' },
    { label: i18n.t('cloudenv.text_517'), value: 'server_perform_rebuild_root' },
    { label: i18n.t('cloudenv.text_354'), value: 'server_perform_syncstatus' },
    { label: i18n.t('cloudenv.text_519'), value: 'server_perform_change_owner' },
    { label: i18n.t('cloudenv.text_521'), value: 'server_perform_create_same_config' },
    { label: i18n.t('cloudenv.text_529'), value: 'server_perform_reset_password' },
    { label: i18n.t('cloudenv.text_530'), value: 'server_perform_bind_key' },
    { label: i18n.t('cloudenv.text_531'), value: 'server_perform_unbind_key' },
    { label: i18n.t('cloudenv.text_533'), value: 'server_perform_mount_iso' },
    { label: i18n.t('compute.vminstance.monitor.install_agent'), value: 'server_perform_detect_ssh_proxy' },
    { label: i18n.t('compute.text_283'), value: 'server_perform_set_user_metadata' },
    { label: i18n.t('cloudenv.text_524'), value: 'server_perform_cancel_expire' },
    { label: i18n.t('cloudenv.text_543'), value: 'server_set_delete_protection' },
    { label: i18n.t('cloudenv.text_108'), value: 'server_perform_delete' },
  ],
  [CATEGORY_KEYS.VMINSTANCE_CONFIGURED_CALLBACK_ADDRESS]: [
    { label: i18n.t('cloudenv.text_544'), value: 'create_callback_address' },
    { label: i18n.t('cloudenv.text_545'), value: 'adjust_configuration_callback_address' },
    { label: i18n.t('cloudenv.text_520'), value: 'create_snapshot_callback_address' },
    { label: i18n.t('cloudenv.text_521'), value: 'create_same_configuration_callback_address' },
    { label: i18n.t('cloudenv.text_525'), value: 'host_clone_callback_address' },
    { label: i18n.t('cloudenv.text_527'), value: 'renew_callback_address' },
    { label: i18n.t('cloudenv.text_546'), value: 'modify_bandwidth_callback_address' },
    { label: i18n.t('cloudenv.text_108'), value: 'delete_callback_address' },
  ],
  [CATEGORY_KEYS.DOCUMENT_CONFIGURED_CALLBACK_ADDRESS]: [
    { label: i18n.t('system.strategydefinition.product_manual_callback_address'), value: 'product_manual_callback_address' },
  ],
  [CATEGORY_KEYS.IMAGE_HIDDEN_MENUS]: [
    { label: i18n.t('cloudenv.text_565'), value: 'image_upload' },
    { label: i18n.t('cloudenv.text_566'), value: 'image_store' },
    { label: i18n.t('cloudenv.text_567'), value: 'image_create_server' },
    { label: i18n.t('cloudenv.text_406'), value: 'image_edit_attribute' },
    { label: i18n.t('cloudenv.text_568'), value: 'iamge_set_public_image' },
    { label: i18n.t('cloudenv.text_569'), value: 'image_set_customize_image' },
    { label: i18n.t('cloudenv.text_281'), value: 'image_set_public' },
    { label: i18n.t('cloudenv.text_519'), value: 'image_change_project' },
    { label: i18n.t('cloudenv.text_543'), value: 'image_set_delete_protection' },
    { label: i18n.t('cloudenv.text_108'), value: 'image_delete' },
    { label: i18n.t('cloudenv.text_570'), value: 'image_create_cache_list' },
    { label: i18n.t('compute.perform_image_probe'), value: 'image_perform_probe' },
  ],
  [CATEGORY_KEYS.DISK_HIDDEN_MENUS]: [
    { label: i18n.t('compute.perform_create'), value: 'disk_create' },
    { label: i18n.t('compute.disk_perform_resize'), value: 'disk_perform_resize' },
    { label: i18n.t('compute.disk_perform_attach'), value: 'disk_perform_attach' },
    { label: i18n.t('compute.disk_perform_detach'), value: 'disk_perform_detach' },
    { label: i18n.t('compute.disk_perform_create_snapshot'), value: 'disk_perform_create_snapshot' },
    { label: i18n.t('compute.create_disk_backup2'), value: 'disk_perform_create_backup' },
    { label: i18n.t('compute.vminstance.change_disk_storage'), value: 'disk_perform_change_disk_storage' },
    { label: i18n.t('compute.disk_perform_setup_snapshot_policy'), value: 'disk_perform_setup_snapshot_policy' },
    { label: i18n.t('compute.perform_change_owner', [i18n.t('dictionary.project')]), value: 'disk_perform_change_project' },
    { label: i18n.t('compute.perform_sync_status'), value: 'disk_perform_syncstatus' },
    // { label: i18n.t('table.action.set_tag'), value: 'disk_perform_set_tags' },
    { label: i18n.t('compute.perform_delete'), value: 'disk_delete' },
  ],
  // [CATEGORY_KEYS.BILL_ASSOCIATE_HIDDEN_COLUMNS]: [
  //   { label: i18n.t('bill.text_127'), value: 'resource_name' },
  //   { label: i18n.t('bill.resource_type'), value: 'resource_type' },
  //   { label: i18n.t('bill.text_121'), value: 'spec' },
  //   { label: i18n.t('bill.text_128'), value: 'amount_table' },
  //   { label: i18n.t('bill.text_122'), value: 'reserved' },
  //   { label: i18n.t('bill.text_123'), value: 'gross_amount' },
  //   { label: i18n.t('bill.text_124'), value: 'discount_amount' },
  //   { label: i18n.t('bill.text_125'), value: 'amount' },
  //   { label: i18n.t('bill.discount'), value: 'discount' },
  //   { label: i18n.t('bill.text_84'), value: 'charge_type' },
  //   { label: i18n.t('table.title.brand'), value: 'brand' },
  //   { label: i18n.t('res.cloudaccount'), value: 'account' },
  //   { label: i18n.t('res.project'), value: 'project' },
  //   { label: i18n.t('bill.text_83'), value: 'region' },
  // ],
  [CATEGORY_KEYS.BILL_RESOURCE_HIDDEN_COLUMNS]: [
    { label: i18n.t('bill.text_127'), value: 'resource_name' },
    { label: i18n.t('bill.text_73'), value: 'resource_type' },
    { label: i18n.t('bill.text_120'), value: 'resource_id' },
    { label: i18n.t('bill.external_id'), value: 'external_id' },
    { label: i18n.t('bill.title.origin_res_type'), value: 'origin_res_type' },
    { label: 'IP', value: 'ip_addr' },
    { label: i18n.t('bill.text_131'), value: 'usage' },
    { label: i18n.t('bill.usage_type'), value: 'usage_type' },
    { label: i18n.t('bill.origin_usage_type'), value: 'origin_usage_type' },
    { label: i18n.t('bill.bill_type.gross_value'), value: 'gross_amount' },
    { label: i18n.t('bill.bill_type.paid_value'), value: 'paid_amount' },
    { label: i18n.t('bill.bill_type.discount_value'), value: 'discount_amount' },
    { label: i18n.t('bill.text_125'), value: 'amount' },
    { label: i18n.t('bill.after_cost_conversion', [i18n.t('bill.text_125')]), value: 'amount_sec' },
    { label: i18n.t('bill.month'), value: 'day' },
    { label: i18n.t('common_261'), value: 'tags' },
    { label: i18n.t('dictionary.project_tag'), t: 'dictionary.project_tag', value: 'project_metadata' },
    { label: i18n.t('bill.text_84'), value: 'charge_type' },
    { label: i18n.t('bill.title.project_type'), value: 'project_type' },
    { label: i18n.t('meter.instance_create_time'), value: 'instance_created_at' },
    { label: i18n.t('meter.instance_delete_time'), value: 'instance_deleted_at' },
    { label: i18n.t('meter.discount_rate'), value: 'discount' },
    { label: i18n.t('meter.usage_unit'), value: 'usage_unit' },
    { label: i18n.t('meter.price_unit'), value: 'price_unit' },
    { label: i18n.t('meter.unit_price'), value: 'rate' },
    { label: i18n.t('meter.instance_type'), value: 'instance_type' },
    { label: i18n.t('meter.usage_duration'), value: 'usage_duration' },
    { label: i18n.t('meter.usage_duration_unit'), value: 'usage_duration_unit' },
    { label: i18n.t('meter.origin_record_type'), value: 'origin_record_type' },
    { label: i18n.t('meter.aggregate_usage'), value: 'aggregate_usage' },
    { label: i18n.t('meter.aggregate_usage_unit'), value: 'aggregate_usage_unit' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('res.cloudaccount'), value: 'account' },
    { label: i18n.t('res.project'), value: 'project' },
    { label: i18n.t('bill.external_project_name'), value: 'external_project_name' },
    { label: i18n.t('dictionary.domain'), value: 'domain' },
    { label: i18n.t('bill.text_83'), value: 'region' },
    { label: i18n.t('meter.origin_region'), value: 'origin_region' },
    { label: i18n.t('meter.bill_impact_factor'), value: 'spec' },
    { label: i18n.t('bill.cloudprovider'), value: 'cloudprovider_id' },
    { label: i18n.t('bill.financial_unit'), value: 'financial_unit' },
    { label: i18n.t('bill.owner_account'), value: 'owner_name' },
    { label: i18n.t('bill.linked_account'), value: 'linked_name' },
  ],
  [CATEGORY_KEYS.BILL_DETAIL_HIDDEN_COLUMNS]: [
    { label: i18n.t('bill.text_134'), value: 'id' },
    { label: i18n.t('bill.text_120'), value: 'resource_id' },
    { label: i18n.t('bill.text_127'), value: 'resource_name' },
    { label: i18n.t('bill.external_id'), value: 'external_id' },
    { label: i18n.t('bill.text_73'), value: 'resource_type' },
    { label: i18n.t('bill.title.origin_res_type'), value: 'origin_res_type' },
    { label: 'IP', value: 'ip_addr' },
    { label: i18n.t('bill.text_131'), value: 'usage' },
    { label: i18n.t('bill.usage_type'), value: 'usage_type' },
    { label: i18n.t('bill.origin_usage_type'), value: 'origin_usage_type' },
    { label: i18n.t('bill.bill_type.gross_value'), value: 'gross_amount' },
    { label: i18n.t('bill.bill_type.paid_value'), value: 'paid_amount' },
    { label: i18n.t('bill.bill_type.discount_value'), value: 'discount_amount' },
    { label: i18n.t('bill.text_125'), value: 'amount' },
    { label: i18n.t('bill.after_cost_conversion', [i18n.t('bill.text_125')]), value: 'amount_sec' },
    { label: i18n.t('common_261'), value: 'tags' },
    { label: i18n.t('dictionary.project_tag'), t: 'dictionary.project_tag', value: 'project_metadata' },
    { label: i18n.t('bill.text_84'), value: 'charge_type' },
    { label: i18n.t('bill.title.project_type'), value: 'project_type' },
    { label: i18n.t('meter.instance_create_time'), value: 'instance_created_at' },
    { label: i18n.t('meter.instance_delete_time'), value: 'instance_deleted_at' },
    { label: i18n.t('meter.discount_rate'), value: 'discount' },
    { label: i18n.t('meter.usage_unit'), value: 'usage_unit' },
    { label: i18n.t('meter.price_unit'), value: 'price_unit' },
    { label: i18n.t('meter.unit_price'), value: 'rate' },
    { label: i18n.t('meter.instance_type'), value: 'instance_type' },
    { label: i18n.t('meter.usage_duration'), value: 'usage_duration' },
    { label: i18n.t('meter.usage_duration_unit'), value: 'usage_duration_unit' },
    { label: i18n.t('meter.origin_record_type'), value: 'origin_record_type' },
    { label: i18n.t('meter.aggregate_usage'), value: 'aggregate_usage' },
    { label: i18n.t('meter.aggregate_usage_unit'), value: 'aggregate_usage_unit' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('res.cloudaccount'), value: 'account' },
    { label: i18n.t('bill.cloudprovider') + '/ID', value: 'cloudprovider_id' },
    { label: i18n.t('bill.external_project_name') + '/ID', value: 'external_project_name' },
    { label: i18n.t('res.project'), value: 'project' },
    { label: i18n.t('dictionary.domain'), value: 'domain' },
    { label: i18n.t('bill.text_83'), value: 'region' },
    { label: i18n.t('meter.origin_region'), value: 'origin_region' },
    { label: i18n.t('meter.bill_impact_factor'), value: 'spec' },
    { label: i18n.t('bill.financial_unit'), value: 'financial_unit' },
    { label: i18n.t('bill.title.day'), value: 'day' },
    { label: i18n.t('bill.owner_account'), value: 'owner_name' },
    { label: i18n.t('bill.linked_account'), value: 'linked_name' },
  ],
  [CATEGORY_KEYS.SERVER_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('compute.power_states'), value: 'power_states' },
    { label: i18n.t('table.title.type'), value: 'is_gpu' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: 'IP', value: 'ips' },
    { label: 'MAC', value: 'macs' },
    { label: i18n.t('table.title.os_arch'), value: 'os_arch' },
    { label: i18n.t('table.title.flavor'), value: 'instance_type' },
    { label: i18n.t('table.title.os'), value: 'os_type' },
    { label: i18n.t('compute.monitor.agent.install_status'), value: 'agent_status' },
    { label: i18n.t('table.title.vmem_size'), value: 'vmem_size' },
    { label: i18n.t('table.title.disk'), value: 'disk' },
    { label: 'CPU', value: 'vcpu_count' },
    { label: i18n.t('table.title.cpu_usage'), value: 'cpu_usage' },
    { label: i18n.t('table.title.mem_usage'), value: 'mem_usage' },
    { label: i18n.t('table.title.disk_usage'), value: 'disk_usage' },
    { label: i18n.t('table.title.init_keypair'), value: 'password' },
    { label: i18n.t('res.secgroup'), value: 'secgroups' },
    { label: 'VPC', value: 'vpc' },
    { label: i18n.t('table.title.bill_type'), value: 'billing_type' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('res.cloudaccount'), value: 'account' },
    { label: i18n.t('res.host'), value: 'host' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.DISK_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: i18n.t('table.title.disk_size'), value: 'disk_size' },
    { label: i18n.t('compute.max_iops'), value: 'iops' },
    { label: i18n.t('table.title.disk_format'), value: 'disk_format' },
    { label: i18n.t('storage.text_38'), value: 'storage_type' },
    { label: i18n.t('table.title.disk_type'), value: 'disk_type' },
    { label: i18n.t('table.title.disk_mounted'), value: 'guest_count' },
    { label: i18n.t('res.server'), value: 'guest' },
    { label: i18n.t('compute.disk_device'), value: 'device' },
    { label: i18n.t('table.title.disk_storage'), value: 'storage' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('table.title.bill_type'), value: 'billing_type' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.cloudaccount'), value: 'account' },
    { label: i18n.t('table.title.disk_medium_type'), value: 'medium_type' },
    { label: i18n.t('compute.text_461'), value: 'snapshotpolicies' },
    { label: i18n.t('compute.title.encryption'), value: 'encryption' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.SNAPSHOT_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: i18n.t('table.title.os_arch'), value: 'os_arch' },
    { label: i18n.t('table.title.snapshot_size'), value: 'size' },
    { label: i18n.t('table.title.disk_type'), value: 'disk_type' },
    { label: i18n.t('res.disk'), value: 'disk_name' },
    { label: i18n.t('storage.text_38'), value: 'storage_type' },
    { label: i18n.t('res.server'), value: 'guest' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('res.cloudaccount'), value: 'account' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('compute.text_1070'), value: 'created_by' },
    { label: i18n.t('compute.text_1071'), value: 'resource' },
    { label: i18n.t('compute.title.encryption'), value: 'encryption' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.EIP_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: 'IP', value: 'ip_addr' },
    { label: i18n.t('network.text_195'), value: 'bandwidth' },
    { label: i18n.t('network.text_192'), value: 'charge_type' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('network.text_196'), value: 'account' },
    { label: i18n.t('network.text_197'), value: 'associate_name' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.NETWORK_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: i18n.t('network.text_249'), value: 'server_type' },
    { label: i18n.t('common_498'), value: 'is_auto_alloc' },
    { label: i18n.t('network.text_213'), value: 'ip' },
    { label: i18n.t('network.ipv6.address'), value: 'ip6' },
    { label: i18n.t('network.ipv6.range'), value: 'guest_ip6_start' },
    { label: i18n.t('network.ipv6.gateway'), value: 'guest_gateway6' },
    { label: i18n.t('network.text_622'), value: 'ports' },
    { label: 'VPC', value: 'vpc' },
    { label: i18n.t('network.text_571'), value: 'wire' },
    { label: 'VLAN', value: 'vlan_id' },
    { label: i18n.t('network.text_630'), value: 'schedtag' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('network.text_196'), value: 'account' },
    { label: i18n.t('cloudenv.text_282'), value: 'public_scope' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.OSS_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: i18n.t('storage.text_38'), value: 'storage_class' },
    { label: i18n.t('storage.text_93'), value: 'acl' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('network.text_196'), value: 'account' },
    { label: i18n.t('cloudenv.text_282'), value: 'public_scope' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('storage.location'), value: 'location' },
    { label: i18n.t('storage.text_139'), value: 'url' },
    { label: i18n.t('storage.text_220'), value: 'cdn_domains' },
    { label: i18n.t('storage.text_230'), value: 'website_url' },
    { label: i18n.t('storage.text_172'), value: 'size' },
    { label: i18n.t('storage.text_144'), value: 'size_limit' },
    { label: i18n.t('storage.text_172'), value: 'referer' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.RDS_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: i18n.t('db.text_61'), value: 'category' },
    { label: i18n.t('db.text_109'), value: 'vcpu_count' },
    { label: i18n.t('db.text_57'), value: 'engine' },
    { label: i18n.t('db.text_152'), value: 'internal_connection_str' },
    { label: i18n.t('db.text_64'), value: 'port' },
    { label: i18n.t('table.title.bill_type'), value: 'billing_type' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('network.text_196'), value: 'account' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('db.text_54'), value: 'charge_type' },
    { label: i18n.t('db.text_166'), value: 'db_info' },
    { label: i18n.t('db.text_171'), value: 'connection_info' },
    { label: i18n.t('db.text_177'), value: 'db_size_gb' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.REDIS_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: i18n.t('db.text_119'), value: 'arch_type' },
    { label: i18n.t('db.text_109'), value: 'instance_type' },
    { label: i18n.t('db.text_112'), value: 'engine' },
    { label: i18n.t('db.text_195'), value: 'password' },
    { label: i18n.t('db.text_152'), value: 'private_dns' },
    { label: i18n.t('db.text_303'), value: 'private_connect_port' },
    { label: i18n.t('table.title.bill_type'), value: 'billing_type' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('network.text_196'), value: 'account' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('db.text_166'), value: 'db_info' },
    { label: i18n.t('db.text_171'), value: 'connection_info' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.SLB_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: i18n.t('network.text_248'), value: 'address' },
    { label: i18n.t('network.text_268'), value: 'loadbalancer_spec' },
    { label: 'VPC', value: 'vpc' },
    { label: i18n.t('network.text_192'), value: 'charge_type' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('network.text_19'), value: 'cluster' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('network.text_196'), value: 'account' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.MONGODB_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: i18n.t('cloudenv.text_459'), value: 'instance_type' },
    { label: i18n.t('db.text_152'), value: 'ip_addr' },
    { label: i18n.t('db.text_377'), value: 'engine_version' },
    { label: i18n.t('db.network_address'), value: 'network_address' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('network.text_196'), value: 'account' },
    { label: i18n.t('res.project'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('db.text_166'), value: 'db_info' },
    { label: i18n.t('db.text_171'), value: 'connection_info' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.VPC_HIDDEN_COLUMNS]: [
    { label: 'ID', value: 'id' },
    { label: i18n.t('table.title.external_id'), value: 'external_id' },
    { label: i18n.t('table.title.name'), value: 'name' },
    { label: i18n.t('common.status'), value: 'status' },
    { label: i18n.t('table.title.tag'), value: 'metadata' },
    { label: i18n.t('network.vpc.cidr_block.ipv4.label'), value: 'cidr_block' },
    { label: i18n.t('network.text_571'), value: 'wire_count' },
    { label: i18n.t('network.text_682'), value: 'network_count' },
    { label: i18n.t('table.title.brand'), value: 'brand' },
    { label: i18n.t('network.text_196'), value: 'account' },
    { label: i18n.t('cloudenv.text_282'), value: 'public_scope' },
    { label: i18n.t('table.title.owner_domain'), value: 'tenant' },
    { label: i18n.t('res.region'), value: 'region' },
    { label: i18n.t('network.text_692'), value: 'routetable_count' },
    { label: i18n.t('network.text_693'), value: 'natgateway_count' },
    { label: i18n.t('network.external_access_mode_label'), value: 'external_access_mode' },
    { label: i18n.t('table.title.create_time'), value: 'created_at' },
    { label: i18n.t('table.title._action'), value: 'perform_action' },
  ],
  [CATEGORY_KEYS.NAVBAR_HIDDEN_ITEMS]: [
    { label: i18n.t('dictionary.monitor_commonalert'), value: 'alert' },
    { label: i18n.t('dictionary.notification'), value: 'notification' },
    { label: i18n.t('common_198'), value: 'workflow' },
    { label: i18n.t('navbar.button.monitor'), value: 'monitor_dashboard' },
    { label: 'CloudShell', value: 'cloudshell' },
    { label: 'AI Agent', value: 'ai' },
    { label: i18n.t('navbar.button.feature_select'), value: 'feature_select' },
    { label: i18n.t('navbar.button.docs'), value: 'docs' },
    { label: i18n.t('navbar.button.about'), value: 'about' },
    // { label: i18n.t('common.more'), value: 'more' },
  ],
  [CATEGORY_KEYS.DASHBOARD_HIDDEN_ACTIONS]: [
    { label: i18n.t('common.action.create'), value: 'create' },
    { label: i18n.t('common.action.edit'), value: 'edit' },
    { label: i18n.t('common.action.export'), value: 'export' },
    { label: i18n.t('common.action.import'), value: 'import' },
    { label: i18n.t('common.action.clone'), value: 'clone' },
    { label: i18n.t('common.action.share'), value: 'share' },
    { label: i18n.t('common.action.reset'), value: 'reset' },
  ],
  [CATEGORY_KEYS.FEE_HIDDEN_ITEMS]: [
    { label: i18n.t('bill.bill_type'), value: 'bill_type' },
    { label: i18n.t('bill.text_81'), value: 'brand' },
    { label: i18n.t('bill.text_244'), value: 'account' },
    { label: i18n.t('bill.owner_account'), value: 'owner' },
    { label: i18n.t('bill.linked_account'), value: 'linked' },
    { label: i18n.t('dictionary.cloudprovider'), t: 'dictionary.cloudprovider', value: 'cloudprovider' },
    { label: i18n.t('dictionary.region'), t: 'dictionary.region', value: 'region' },
    { label: i18n.t('meter.origin_region'), value: 'origin_region' },
    { label: i18n.t('bill.text_84'), value: 'charge_type' },
    { label: i18n.t('dictionary.domain'), t: 'dictionary.domain', value: 'domain' },
    { label: i18n.t('dictionary.project'), t: 'dictionary.project', value: 'project' },
    { label: i18n.t('bill.text_73'), value: 'resource_type' },
    { label: i18n.t('bill.cloud_res_type'), value: 'origin_res_type' },
    { label: i18n.t('meter.bill_impact_factor'), value: 'spec' },
    { label: i18n.t('bill.financial_unit'), value: 'financial_unit' },
    { label: i18n.t('bill.title.project_type'), value: 'project_type' },
    { label: i18n.t('bill.external_project_name'), value: 'external_project_name' },
    { label: i18n.t('bill.usage_type'), value: 'usage_type' },
    { label: i18n.t('bill.origin_usage_type'), value: 'origin_usage_type' },
    { label: i18n.t('meter.origin_record_type'), value: 'origin_record_type' },
    { label: i18n.t('bill.text_79'), value: 'tag' },
    { label: i18n.t('dictionary.project_tag'), t: 'dictionary.project_tag', value: 'project_tag' },
    { label: i18n.t('bill.product_type'), value: 'spec' },
    { label: i18n.t('bill.financial_unit'), value: 'financial_unit' },
    { label: i18n.t('bill.cloud_res_type'), value: 'origin_res_type' },
    { label: i18n.t('bill.title.project_type'), value: 'project_type' },
    { label: i18n.t('bill.resource_tag'), value: 'instance_tag' },
    { label: i18n.t('dictionary.instance_tag'), t: 'dictionary.instance_tag', value: 'instance_tag' },
  ],
  [CATEGORY_KEYS.SERVER_DURATION]: [],
  [CATEGORY_KEYS.VMINSTANCE_MONITOR_TEMPLATE]: [],
  [CATEGORY_KEYS.HOST_MONITOR_TEMPLATE]: [],
  [CATEGORY_KEYS.VMINSTANCE_CONTAINER_MONITOR_TEMPLATE]: [],
  [CATEGORY_KEYS.CONTAINER_MONITOR_TEMPLATE]: [],
  [CATEGORY_KEYS.RDS_MONITOR_TEMPLATE]: [],
  [CATEGORY_KEYS.REDIS_MONITOR_TEMPLATE]: [],
  [CATEGORY_KEYS.BLOCKSTORAGE_MONITOR_TEMPLATE]: [],
  [CATEGORY_KEYS.BUCKET_MONITOR_TEMPLATE]: [],
  [CATEGORY_KEYS.BAREMETAL_MONITOR_TEMPLATE]: [],
}

export function getPolicies () {
  if (!_policies[CATEGORY_KEYS.SUB_HIDDEN_MENUS]) {
    const menus = _getsubmenus()
    _policies[CATEGORY_KEYS.SUB_HIDDEN_MENUS] = menus
  }
  return _policies
}

function _getstr (v) {
  if (R.is(Function, v)) {
    return v()
  } else {
    return '' + v
  }
}

function _getpath (p) {
  let v = p
  while (v.substr(0, 1) === '/') {
    v = v.substr(1)
  }
  return v.replaceAll('/', '_').replaceAll('-', '_')
}

function _getsubmenus () {
  const ret = []
  const routes = allRoutes
  // const r = require.context('../../../..', true, /^((?![\\/]node_modules).)*.\/router\/index.js$/)
  // r.keys().forEach(dir => {
  //   if (!dir.match(/Dashboard/)) {
  //     routes = routes.concat(r(dir).default)
  //   }
  // })
  routes.sort((a, b) => a.index - b.index)
  // setup 2nd-level menus
  for (let i = 0; i < routes.length; i++) {
    const route = routes[i]
    const routeLabel = _getstr(route.meta.label)
    if (route.menus) {
      for (let j = 0; j < route.menus.length; j++) {
        const menu = route.menus[j]
        const menuLabel = _getstr(menu.meta.label)
        if (menu.submenus) {
          for (let k = 0; k < menu.submenus.length; k++) {
            const submenu = menu.submenus[k]
            const label = routeLabel + ' - ' + menuLabel + ' - ' + _getstr(submenu.meta.label)
            const value = _getpath(submenu.path)
            ret.push({ label: label + ' (' + value + ')', value })
          }
        } else {
          const value = _getpath(menu.path)
          const label = routeLabel + ' - ' + menuLabel
          ret.push({ label: label + ' (' + value + ')', value })
        }
      }
    } else if (route.menu) {
      const value = _getpath(route.menu.path)
      ret.push({ label: routeLabel + ' (' + value + ')', value })
    }
  }
  return ret
}

/**
  * @description 转换policies数据格式，用于映射
  * @returns {
  *   vminstance_hidden_menus: { server_create: '新建', ... },
  *   ...
  * }
*/
export function getPoliciesValueMap () {
  const policies = getPolicies()
  const ret = {}
  R.forEachObjIndexed((value, key) => {
    const obj = {}
    ret[key] = {}
    value.map(item => {
      obj[item.value] = item.label
    })
    ret[key] = obj
  }, policies)
  return ret
}
